
/**
 * 差出人情報テーブル定義
 */
export class SenderInfoDbEntity {

    /**
     * 住所
     */
    public addresses: SenderInfoAddressDbEntity[];

    /**
     * 会社
     */
    public corps: SenderInfoCorpDbEntity[];

    /**
     * 名前
     */
    public names: SenderInfoNameDbEntity[];

    /**
     * Eメール
     */
    public emails: SenderInfoEmailDbEntity[];

    /**
     * free
     */
    public free: string;

    /**
     * スタッフ
     */
    public staff: string;

    /**
     * 自由入力
     */
    public isHojin: boolean;
}

/**
 * 差出人情報テーブル定義(住所)
 */
export class SenderInfoAddressDbEntity {

    public topstr: string;
    public yubin1: string;
    public yubin2: string;
    public jusho1: string;
    public jusho2: string;
    public jusho3: string;
    public telType1: number;
    public telTopStr1: string;
    public telNo1_1: string;
    public telNo1_2: string;
    public telNo1_3: string;
    public telEndStr1: string;
    public telType2: number;
    public telTopStr2: string;
    public telNo2_1: string;
    public telNo2_2: string;
    public telNo2_3: string;
    public telEndStr2: string;

}

/**
 * 差出人情報テーブル定義(会社)
 */
export class SenderInfoCorpDbEntity {

    public maekabu: string;
    public name: string;
    public busyo: string;

}

/**
 * 差出人情報テーブル定義(名前)
 */
export class SenderInfoNameDbEntity {

    public title: string;
    public firstName: string
    public firstRubi: string;
    public lastName: string;
    public lastRubi: string;
    public ps: string;

}

/**
 * 差出人情報テーブル定義(Eメール)
 */
export class SenderInfoEmailDbEntity {
    public topstr: string;
    public type: number;
    public address: string;
    public endstr: string;
    //public free: string;
    //public staff: string;
    //public isHojin: boolean;
}


